import {
  Box,
  Button,
  Dialog,
  Stack,
  Typography,
  useMediaQuery,
  Grid,
  TextField,
  InputAdornment,
  MenuItem,
  IconButton,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { Divider } from 'antd';
import { depositPayment, getApiCall } from 'api/apiService';
import { textboxmargin } from 'component/PropertyCreation/PropertyCreation.style';
import { GET_DEPOSIT } from 'constant/app.config';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import successgif from 'assets/gifs/successgif.gif';
import { poppins400 } from 'theme/common.style';
import moment from 'moment';
import Loading from 'assets/images/loading.png';

const Pendingwarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

const PrivacyDocument = () => {
  return (
    <svg
      width="107"
      height="121"
      viewBox="0 0 107 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12.8915V100.024C2 106.039 6.86663 110.915 12.8699 110.915H78.0895C84.093 110.915 88.9595 106.039 88.9595 100.024V36.535C88.9595 33.6039 87.7806 30.7966 85.6887 28.7475L61.5558 5.10403C59.5248 3.11415 56.7975 2 53.9566 2H12.8699C6.86663 2 2 6.8763 2 12.8915Z"
        stroke="#4B4B4B"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g clip-path="url(#clip0_41688_175725)">
        <path
          d="M45 37C50.718 42.6257 58.1809 45.5548 65.8075 45.1667C66.9179 49.3671 67.2576 53.7729 66.8066 58.1222C66.3555 62.4715 65.1229 66.6757 63.1819 70.4848C61.2409 74.2939 58.6311 77.6302 55.5077 80.2955C52.3843 82.9609 48.8109 84.9008 45 86C41.1891 84.9008 37.6157 82.9609 34.4923 80.2955C31.3689 77.6302 28.7591 74.2939 26.8181 70.4848C24.8771 66.6757 23.6445 62.4715 23.1934 58.1222C22.7424 53.7729 23.0821 49.3671 24.1925 45.1667C31.8191 45.5548 39.282 42.6257 45 37Z"
          fill="#F0F0F0"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g clip-path="url(#clip1_41688_175725)">
          <path
            d="M51.5 59.5H39C37.6193 59.5 36.5 60.6193 36.5 62V69.5C36.5 70.8807 37.6193 72 39 72H51.5C52.8807 72 54 70.8807 54 69.5V62C54 60.6193 52.8807 59.5 51.5 59.5Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M45.25 67C45.9404 67 46.5 66.4404 46.5 65.75C46.5 65.0596 45.9404 64.5 45.25 64.5C44.5596 64.5 44 65.0596 44 65.75C44 66.4404 44.5596 67 45.25 67Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M40.25 59.5V54.5C40.25 53.1739 40.7768 51.9021 41.7145 50.9645C42.6521 50.0268 43.9239 49.5 45.25 49.5C46.5761 49.5 47.8479 50.0268 48.7855 50.9645C49.7232 51.9021 50.25 53.1739 50.25 54.5V59.5"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_41688_175725">
          <rect
            width="105"
            height="119"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
        <clipPath id="clip1_41688_175725">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(30.25 45.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Calendarimg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4.43245C7 4.27684 7 4.19903 6.9491 4.15423C6.89819 4.10944 6.82244 4.11915 6.67094 4.13857C5.54965 4.28229 4.76806 4.57508 4.17157 5.17157C3 6.34315 3 8.22876 3 12C3 15.7712 3 17.6569 4.17157 18.8284C5.34315 20 7.22876 20 11 20H13C16.7712 20 18.6569 20 19.8284 18.8284C21 17.6569 21 15.7712 21 12C21 8.22876 21 6.34315 19.8284 5.17157C19.2319 4.57508 18.4504 4.28229 17.3291 4.13857C17.1776 4.11915 17.1018 4.10944 17.0509 4.15424C17 4.19903 17 4.27684 17 4.43245L17 6.5C17 7.32843 16.3284 8 15.5 8C14.6716 8 14 7.32843 14 6.5L14 4.30005C14 4.15898 14 4.08844 13.9561 4.04451C13.9123 4.00059 13.8418 4.0005 13.7009 4.00031C13.4748 4 13.2412 4 13 4H11C10.7588 4 10.5252 4 10.2991 4.00031C10.1582 4.0005 10.0877 4.00059 10.0439 4.04452C10 4.08844 10 4.15898 10 4.30005L10 6.5C10 7.32843 9.32843 8 8.50001 8C7.67158 8 7 7.32843 7 6.5L7 4.43245Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path d="M8.5 2.5L8.5 6.5" stroke="white" stroke-linecap="round" />
      <path d="M15.5 2.5L15.5 6.5" stroke="white" stroke-linecap="round" />
      <circle cx="7.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="16.5" r="0.5" fill="white" />
    </svg>
  );
};

const ImageSvg = () => {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.8399 16.625H21.0781C16.0312 16.625 11.875 20.7085 11.875 25.7287V62.1463C11.875 67.1665 16.0312 71.25 21.0781 71.25H66.7969C71.8438 71.25 76 67.3639 76 62.3438V25.7287C76 20.7085 71.8913 16.625 66.8399 16.625ZM55.388 25.7302C56.7366 25.7384 58.0527 26.1458 59.1701 26.9011C60.2875 27.6563 61.1562 28.7256 61.6666 29.9739C62.1771 31.2223 62.3064 32.5939 62.0382 33.9157C61.7701 35.2375 61.1165 36.4502 60.1599 37.401C59.2034 38.3518 57.9867 38.998 56.6633 39.2581C55.3399 39.5182 53.9691 39.3806 52.7239 38.8626C51.4786 38.3446 50.4147 37.4694 49.6662 36.3474C48.9177 35.2255 48.5183 33.907 48.5183 32.5583C48.5254 30.7422 49.2527 29.0031 50.5406 27.7227C51.8285 26.4422 53.5719 25.7251 55.388 25.7287V25.7302ZM21.0173 66.6989C18.4938 66.6989 16.5849 64.6579 16.5849 62.1478V52.5246L30.0126 40.5323C31.3253 39.3777 33.0269 38.7636 34.7745 38.814C36.5221 38.8644 38.1855 39.5755 39.4295 40.804L48.7276 50.0234L31.9541 66.6974L21.0173 66.6989ZM71.25 62.1463C71.2498 62.7446 71.1317 63.3369 70.9025 63.8894C70.6732 64.442 70.3373 64.944 69.914 65.3666C69.4906 65.7893 68.9881 66.1244 68.4352 66.3527C67.8822 66.5811 67.2897 66.6982 66.6915 66.6974H38.4453L55.8244 49.4297C57.0577 48.3893 58.6181 47.8166 60.2316 47.8123C61.8451 47.808 63.4086 48.3722 64.6475 49.4059L71.25 55.0095V62.1463Z"
        fill="#2F74EE"
      />
      <path
        d="M57 4.75H9.5C6.98044 4.75 4.56408 5.75089 2.78249 7.53249C1.00089 9.31408 0 11.7304 0 14.25L0 52.25C0.00173749 54.3562 0.702168 56.4024 1.99154 58.0678C3.28091 59.7332 5.08636 60.9239 7.125 61.4531V22.5625C7.125 19.728 8.251 17.0096 10.2553 15.0053C12.2596 13.001 14.978 11.875 17.8125 11.875H66.2031C65.6739 9.83636 64.4832 8.03091 62.8178 6.74154C61.1524 5.45217 59.1062 4.75174 57 4.75Z"
        fill="#2F74EE"
      />
    </svg>
  );
};

const LocationIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: 'middle' }}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
        fill="#112347"
      />
    </svg>
  );
};

const DepositPaymentRemittancePopup = (props) => {
  let { open, groupIt, groupCall, setPaymentPop, getBuyerIndividualValue } =
    props;
  const params = useParams();
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  const [formData, setFormData] = useState({
    amount: '',
    reference: '',
    paymentType: '',
    datePaid: null,
    payerName: '',
    bank: '',
  });

  function addMonths(date, months) {
    date?.setMonth(date?.getMonth() + months);
    return date;
  }

  const handleChange = (field) => (event) => {
    let { value } = event.target;
    if (field === 'amount') {
      const cleaned = value.replace(/\D/g, '');
      if (cleaned.length > 9) return;
      const numericValue = Number(cleaned);
      const buyerOfferPrice = Number(
        getDepositDetails?.depositDetails?.unformattedBuyerOfferPrice || 0
      );

      const paidAmount = Number(
        getDepositDetails?.depositDetails?.paidAmount || 0
      );

      const remainingAmount = buyerOfferPrice - paidAmount;

      if (numericValue > remainingAmount) {
        const formattedOfferPrice = buyerOfferPrice.toLocaleString('en-US');
        setFormErrors((prev) => ({
          ...prev,
          amount: `You cannot transfer an amount greater than the offered price.`,
        }));
        return;
      }
      const formatted = numericValue.toLocaleString('en-US');
      setFormData((prev) => ({
        ...prev,
        amount: formatted,
        unformattedAmount: cleaned,
      }));
      setFormErrors((prev) => ({
        ...prev,
        [field]: '',
      }));

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [field]: '',
    }));
  };

  const handleCancel = () => {
    setFormData({
      amount: '',
      unformattedAmount: '',
      reference: '',
      paymentType: '',
      datePaid: null,
      payerName: '',
      bank: '',
    });
  };

  const handleDateChange = (newDate) => {
    setFormData((prev) => ({
      ...prev,
      datePaid: newDate,
    }));
    setFormErrors((prev) => ({
      ...prev,
      datePaid: '', // clear error
    }));
  };

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [maxFileSize, setMaxFileSize] = useState(false);
  const [formErrors, setFormErrors] = useState({
    depositFile: '',
    fileSizeError: '',
  });

  const [getDepositDetails, setGetDepositDetails] = useState();
  const GetDeposit = () => {
    let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
    getApiCall(`${GET_DEPOSIT.replace(/\/$/, '')}/${propertyId}`, {
      method: 'GET',
      headers: {
        Authorization: accesstoken,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      const rawAmount = res?.data?.depositDetails?.unformattedAmount || '';
      const formattedAmount = Number(rawAmount).toLocaleString('en-US');
      setGetDepositDetails(res?.data);
      setFormData((prev) => ({
        ...prev,
        amount: formattedAmount,
        unformattedAmount: rawAmount,
      }));
    });
  };

  const getFormattedAmount = (amount) => {
    if (!amount) return '';
    const number = Number(String(amount).replace(/,/g, ''));
    return isNaN(number) ? '' : number.toLocaleString('en-US');
  };

  useEffect(() => {
    GetDeposit();
  }, []);

  let propertyId = params?.propertyId;

  const [submitLoader, setSubmitLoader] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const formattedDate = moment(formData.datePaid).format('YYYY-MM-DD');

  const ErrorTxtStyles = {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'poppins',
  };

  const validate = () => {
    const errors = {};
    const numericValue = Number(String(formData.amount).replace(/,/g, ''));
    const apiValue = Number(
      getDepositDetails?.depositDetails?.unformattedBuyerOfferPrice
    );

    if (numericValue == 0) {
      setFormErrors((prev) => ({
        ...prev,
        amount: (
          <Typography sx={ErrorTxtStyles}>Please enter valid amount</Typography>
        ),
      }));
      return false;
    }
    if (numericValue > apiValue) {
      setFormErrors((prev) => ({
        ...prev,
        amount: (
          <Typography sx={ErrorTxtStyles}>
            Amount cannot exceed {`${apiValue.toLocaleString('en-US')}`}
          </Typography>
        ),
      }));
      return false;
    }

    if (!formData.reference?.trim()) {
      errors.reference = (
        <Typography sx={ErrorTxtStyles}>
          Payment reference is required
        </Typography>
      );
    }

    if (!formData.paymentType) {
      errors.paymentType = (
        <Typography sx={ErrorTxtStyles}>
          Please select a payment type
        </Typography>
      );
    }

    if (!formData.datePaid) {
      errors.datePaid = (
        <Typography sx={ErrorTxtStyles}>Date paid is required</Typography>
      );
    }

    if (!formData.payerName?.trim()) {
      errors.payerName = (
        <Typography sx={ErrorTxtStyles}>Payer name is required</Typography>
      );
    }

    if (!formData.bank) {
      errors.bank = (
        <Typography sx={ErrorTxtStyles}>Please select a bank</Typography>
      );
    }

    if (uploadedFiles.length === 0) {
      errors.depositFile = (
        <Typography sx={ErrorTxtStyles}>Upload a supporting file</Typography>
      );
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmitRemittance = async () => {
    setSubmitLoader(true);

    // Perform validation
    if (!validate()) {
      setSubmitLoader(false);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('propertyId', propertyId || '');
    formDataToSend.append(
      'depositAmount',
      String(formData.amount).replace(/[$,]/g, '') || ''
    );
    formDataToSend.append('depositMethod', formData.paymentType || '');
    formDataToSend.append(
      'reference',
      String(formData.reference).replace(/[$,]/g, '') || ''
    );
    formDataToSend.append(
      'madeBy',
      String(formData.payerName).replace(/[$,]/g, '') || ''
    );
    formDataToSend.append('bank', formData.bank || '');
    formDataToSend.append('paidDate', formattedDate || '');

    if (uploadedFiles.length > 0) {
      formDataToSend.append('depositFile', uploadedFiles[0]);
    }

    try {
      const res = await depositPayment(formDataToSend);
      if (res?.status === 1) {
        setApiSuccess(true);
        handleCancel(); // Reset form or close dialog
        groupCall(); // Refresh or re-fetch
        groupIt(); // Additional logic
      } else {
        setApiSuccess(false);
        Swal.fire({
          title: res?.heading || 'Error',
          text: res?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      console.error('API Error:', error);
    } finally {
      setSubmitLoader(false);
    }
  };

  useEffect(() => {
    if (submitLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [submitLoader]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/png': [],
      'image/jpeg': [],
      'application/pdf': [],
    },
    maxSize: 15728640, // 15 MB
    maxFiles: 1,
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        const extension = file.name.split('.').pop().toLowerCase();

        const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
        if (!allowedExtensions.includes(extension)) {
          const errors = {
            depositFile: (
              <Typography sx={ErrorTxtStyles}>
                Only .png, .jpeg and .pdf formats are supported.
              </Typography>
            ),
          };
          setFormErrors(errors);
          setUploadedFiles([]);
          return;
        }

        setUploadedFiles([file]);
        setMaxFileSize(false);
        setFormErrors({});
      }
    },
    onDropRejected: (fileRejections) => {
      const isFileTooLarge = fileRejections.some((file) =>
        file.errors.some((e) => e.code === 'file-too-large')
      );

      if (isFileTooLarge) {
        setMaxFileSize(true);

        const errors = {
          depositFile: (
            <Typography sx={ErrorTxtStyles}>
              Maximum 15 MB only allowed
            </Typography>
          ),
        };

        setFormErrors(errors);
        return;
      }

      const isInvalidType = fileRejections.some((file) =>
        file.errors.some((e) => e.code === 'file-invalid-type')
      );

      if (isInvalidType) {
        const errors = {
          depositFile: (
            <Typography sx={ErrorTxtStyles}>
              Only .jpg, .jpeg, .png, and .pdf formats are supported
            </Typography>
          ),
        };

        setFormErrors(errors);
        return;
      }
    },
  });

  const handleRemoveFile = () => {
    setUploadedFiles([]);
  };

  const handleIconClick = () => {
    setDatePickerOpen(true);
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '865px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
        },
      }}
    >
      {!apiSuccess ? (
        <Grid container height={'100%'}>
          <Grid
            item
            xs={12}
            sx={{
              padding: matchessm ? '30px 20px' : '20px 30px',
              display: 'flex',
              flexDirection: 'row',
              height: '186px',
            }}
          >
            <Grid
              xs={10}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                  fontFamily: 'Poppins',
                }}
              >
                {
                  getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName
                }
              </Typography>
              <Stack direction={'row'} spacing={1}>
                <Pendingwarning />
                <Typography
                  sx={{
                    fontSize: matchessm ? '16px' : '24px',
                    paddingLeft: '12px',
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                  }}
                >
                  Deposit Payment - Remittance
                </Typography>
              </Stack>
              <Typography
                sx={{
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                }}
              >
                Please confirm the Electronic Funds Transfer (EFT) Deposit
                Payment details for{' '}
                <Box
                  sx={{
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                  }}
                >
                  {
                    getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName
                  }
                </Box>
              </Typography>
            </Grid>
            <Grid
              xs={2}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <PrivacyDocument />
            </Grid>
          </Grid>
          <Divider />

          <Grid
            item
            xs={12}
            py={2}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: matchessm ? '10px' : '20px',
              padding: matchessm ? '30px 20px' : '20px 30px',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'poppins',
                fontSize: matchessm ? '20px' : '24px',
                color: 'black',
                fontWeight: 400,
                margingBottom: '20px',
              }}
            >
              Payment Details
            </Typography>

            <Grid container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Payment Amount:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  autoComplete="off"
                  value={getFormattedAmount(formData.amount)}
                  onChange={handleChange('amount')}
                  error={!!formErrors.amount}
                  helperText={formErrors.amount}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                    inputMode: 'numeric',
                  }}
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                      },
                      '& .MuiFormHelperText-root': {
                        fontFamily: 'Poppins, sans-serif',
                      },
                    },
                  ]}
                />
              </Grid>
            </Grid>

            <Grid container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Payment Reference:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  value={formData.reference}
                  onChange={handleChange('reference')}
                  error={!!formErrors.reference}
                  helperText={formErrors.reference}
                  fullWidth
                  placeholder="The reference you made for this transfer"
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                      },
                    },
                  ]}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Payment Type:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  select
                  value={formData.paymentType}
                  onChange={handleChange('paymentType')}
                  fullWidth
                  error={!!formErrors.paymentType}
                  helperText={formErrors.paymentType}
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (selected) =>
                      selected ? selected : 'Please select payment type',
                  }}
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      '& .MuiSelect-root': {
                        color: formData.paymentType ? '#000' : '#999',
                      },
                    },
                  ]}
                >
                  <MenuItem value="" disabled hidden>
                    Please select payment type
                  </MenuItem>
                  <MenuItem value="EFT">EFT</MenuItem>
                  <MenuItem disabled value="BPAY">
                    BPAY
                  </MenuItem>
                  <MenuItem disabled value="Other">
                    Other
                  </MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Grid container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Date Paid:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      open={datePickerOpen}
                      onOpen={() => setDatePickerOpen(true)}
                      onClose={() => setDatePickerOpen(false)}
                      minDate={dayjs(addMonths(new Date(), -1))}
                      maxDate={dayjs(new Date())}
                      value={formData.datePaid}
                      onChange={handleDateChange}
                      format="DD-MM-YYYY"
                      sx={{
                        ...textboxmargin,
                        width: '100%',
                        '& .MuiInputBase-root': {
                          height: '50px',
                          alignItems: 'center',
                        },
                      }}
                      slotProps={{
                        textField: {
                          placeholder: 'Select date',
                          fullWidth: true,
                          error: !!formErrors.datePaid,
                          helperText: formErrors.datePaid,
                          InputProps: {
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                onClick={handleIconClick}
                                style={{ cursor: 'pointer' }}
                              >
                                <Calendarimg />
                              </InputAdornment>
                            ),
                            sx: {
                              fontSize: matchessm ? '12px' : '16px',
                              fontFamily: 'Poppins',
                              color: '#666666',
                              '& input::placeholder': {
                                fontSize: matchessm ? '12px' : '16px',
                                fontFamily: 'Poppins',
                              },
                            },
                          },
                          inputProps: {
                            onClick: () => setDatePickerOpen(true),
                          },
                        },
                        openPickerButton: {
                          sx: { display: 'none' },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
            </Grid>

            <Grid container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Payment Made by:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  value={formData.payerName}
                  onChange={handleChange('payerName')}
                  error={!!formErrors.payerName}
                  helperText={formErrors.payerName}
                  fullWidth
                  placeholder="Account Name in which payment was made"
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                      },
                    },
                  ]}
                />
              </Grid>
            </Grid>

            <Grid container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Bank:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  select
                  value={formData.bank}
                  onChange={handleChange('bank')}
                  error={!!formErrors.bank}
                  helperText={formErrors.bank}
                  fullWidth
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (selected) =>
                      selected ? selected : 'Select bank',
                  }}
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      '& .MuiSelect-root': {
                        color: formData.bank ? '#000' : '#999',
                      },
                    },
                  ]}
                >
                  <MenuItem value="" disabled hidden>
                    Select bank
                  </MenuItem>
                  <MenuItem value="Commonwealth">Commonwealth</MenuItem>
                  <MenuItem value="ANZ">ANZ</MenuItem>
                  <MenuItem value="Westpac">Westpac</MenuItem>
                  <MenuItem value="NAB">NAB</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Box
                {...getRootProps()}
                sx={{
                  border: `1px solid ${
                    formErrors.depositFile && uploadedFiles.length === 0
                      ? '#d32f2f' // red if there's an error and no file
                      : '#2F74EE' // blue default
                  }`,
                  borderRadius: '10px',
                  padding: '40px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  gap: 1,
                  marginTop: '20px',
                  backgroundColor: '#FAFAFA',
                  cursor: 'pointer',
                }}
              >
                <input {...getInputProps()} />

                <Box>
                  <ImageSvg />
                </Box>
                <Typography fontFamily="poppins" fontWeight={500}>
                  Drag & Drop
                </Typography>
                <Typography fontFamily="poppins" fontWeight={500}>
                  or{' '}
                  <span
                    style={{ color: '#2F74EE', textDecoration: 'underline' }}
                  >
                    browse
                  </span>
                </Typography>
                <Typography variant="caption" fontFamily="poppins">
                  Support PNG, JPEG, PDF (Max 15 MB only)
                </Typography>

                {/* ✅ Only show error when no file is uploaded */}
                {formErrors.depositFile && uploadedFiles.length === 0 && (
                  <Typography
                    variant="caption"
                    sx={{ fontFamily: 'poppins', color: '#d32f2f', mt: 1 }}
                  >
                    {formErrors.depositFile}
                  </Typography>
                )}

                {/* ✅ Show uploaded file */}
                {uploadedFiles.length > 0 && (
                  <Box mt={2} width="100%">
                    <Typography fontWeight={600} mb={1} fontSize="14px">
                      Selected File:
                    </Typography>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      px={2}
                      py={1}
                      sx={{
                        backgroundColor: '#F0F0F0',
                        borderRadius: '6px',
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontFamily="poppins"
                        fontSize="14px"
                        sx={{ wordBreak: 'break-all' }}
                      >
                        📄 {uploadedFiles[0].name}
                      </Typography>

                      <Box
                        // 🧱 completely isolates the delete icon from any parent click (like file upload)
                        onClick={(e) => e.stopPropagation()}
                      >
                        <IconButton
                          onClick={(e) => {
                            if (submitLoader) return; // 🚫 Ignore clicks during loading
                            handleRemoveFile();
                          }}
                          disabled={submitLoader}
                          size="small"
                          sx={{
                            opacity: submitLoader ? 0.5 : 1, // dim visually
                            cursor: submitLoader ? 'not-allowed' : 'pointer',
                            pointerEvents: submitLoader ? 'none' : 'auto', // block actual clicks
                          }}
                        >
                          <DeleteForeverIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent="flex-end"
            gap={2}
            sx={{ padding: matchessm ? '30px 20px' : '20px 30px' }}
          >
            <Grid item>
              <Button
                onClick={() => {
                  handleCancel();
                  setPaymentPop(false);
                }}
                variant="outlined"
                disabled={submitLoader}
                sx={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: 400,
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: '#4CA4D6',
                  },
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                onClick={handleSubmitRemittance}
                variant="outlined"
                disabled={submitLoader}
                sx={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                  backgroundColor: '#4CA4D6',
                  '&:hover': {
                    color: '#FFFFFF',
                    backgroundColor: '#4CA4D6',
                  },
                }}
              >
                Submit
              </Button>
              {submitLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid sx={{ padding: '25px' }}>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '18px' : '20px',
                color: '#666666',
                fontWeight: 400,
                display: 'flex',
              }}
            >
              <LocationIcon />
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
            }}
          >
            <Typography
              style={{
                color: 'rgb(154, 188, 102)',
                textAlign: 'center',
                fontFamily: 'poppins',
                fontSize: matchessm ? '20px' : '24px',
              }}
            >
              Payment Successful !
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              margin: 'auto',
              width: matchessm ? '200px' : 'auto',
              height: matchessm ? '200px' : 'auto',
            }}
          >
            <img
              src={successgif}
              alt="successgif"
              sx={{
                width: '36px',
                height: '36px',
              }}
            />
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={'40px'}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '10px 25px' : '20px 50px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '16px' : '18px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  setPaymentPop(false);
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
};

export default DepositPaymentRemittancePopup;
